import { id } from "date-fns/locale";
import _ from "underscore";

import SimpleWarningDialog from "../../../components/SimpleWarningDialog";

import AuthorizationApi from "../../../service/AuthorizationService";

export default {
  name: "Authorizationpanel",
  mixins: [],
  components: {
    SimpleWarningDialog
  },
  data() {
    return {
      tab: null,
      pageType: "AuthorizationPanel",
      ineligibleProfiles: ["IsYatApiUserProfile"],
      ineligibleRoles: [
        "WebAgentConsultantRole",
        "WebAgentApproverRole",
        "IsYatApiUserRole",
        "AuthenticationRole",
        "BaseRole"
      ],
      profileResponse: [],
      rolesResponse: [],
      profileForm: {
        id: null,
        name: null,
        description: null,
        roles: [],
        visible: false,
        step: 1
      },
      profileList: [],
      roleList: [],
      userForm: {
        id: null,
        userName: null,
        email: null,
        profile: null,
        unitCode: null,
        searchInput: null,
        visible: false,
        step: 1,
        type: 1
      },
      searchFullName: null,
      searchUserName: null,
      items: [],
      pageOptions: {
        page: 1,
        itemsPerPage: 10
      },
      userDeleteDialog: false,
      userChangeStatusActiveDialog:false,
      userChangeStatusPassiveDialog:false,
      profileDeleteDialog: false,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("fullName"),
          value: "fullName",
          filterable: true
        },
        {
          text: this.$t("username"),
          value: "userName",
          filterable: true
        },
        {
          text: this.$t("profile"),
          value: "profileLabel",
          filterable: false
        },
        {
          text: this.$t("unit"),
          value: "unitCodeLabel",
          filterable: false
        },
        {
          text: this.$t("pool"),
          value: "pool",
          filterable: false
        },
        {
          text: this.$t("status"),
          value: "statusLabel",
          filterable: false
        },
        {
          text: this.$t("actions"),
          value: "actions",
          filterable: false
        }
      ];
    },
    profileHeaders() {
      return [
        {
          text: this.$t("profile"),
          value: "text",
          filterable: false
        },
        {
          text: this.$t("description"),
          value: "description",
          filterable: false
        },
        {
          text: this.$t("actions"),
          value: "actions",
          filterable: false
        }
      ];
    },
    searchComputed: function() {
      return JSON.stringify({
        userName: this.searchUserName,
        fullName: this.searchFullName
      });
    },
    poolOffset: function() {
      return this.userForm.profile != null ? 0 : 8;
    },
    unitCodePool: function() {
      if (this.userForm.unitCode.unitCode != null) {
        return this.userForm.unitCode.unitCode == "001"
          ? "Genel Müdürlük"
          : "Şube";
      }
      return this.userForm.unitCode == "001" ? "Genel Müdürlük" : "Şube";
    },
    rules: function() {
      let vm = this;
      return {
        descriptionRequired: v =>
          !!v || this.$t("description") + " " + this.$t("fieldRequired"),
        emailRequired: v => !!v || this.$t("emailFieldRequired"),
        emailValid: v =>
          /.+@.+\..+/.test(v) || this.$t("pleaseEnterValidEmail"),
        emailValidLength: v => {
          if (v) {
            const groups = /(.+)@(.+)\.(.+)/g.exec(v);
            return (
              (groups &&
                groups[1].length <= 64 &&
                groups[2].length + groups[3].length <= 255) ||
              this.$t("invalidEmailLength")
            );
          } else {
            return false;
          }
        },
        emailExists: function(v) {
          if (vm.items != null && vm.items.length > 0) {
            if (
              vm.userForm.type == 1 &&
              vm.items.find(user => user.email == v) != null
            ) {
              return vm.$t("emailAlreadyExists");
            }
            return true;
          } else {
            return true;
          }
        },
        fullNameRequired: v =>
          !!v || this.$t("fullName") + " " + this.$t("fieldRequired"),
        userNameRequired: v =>
          !!v || this.$t("username") + " " + this.$t("fieldRequired"),
        userNameExists: function(v) {
          if (vm.items != null && vm.items.length > 0) {
            if (
              vm.userForm.type == 1 &&
              vm.items.find(user => user.userName == v) != null
            ) {
              return vm.$t("usernameAlreadyExists");
            }
            return true;
          } else {
            return true;
          }
        },
        unitCodeRequired: v =>
          !!v || this.$t("unit") + " " + this.$t("fieldRequired"),
        profileRequired: v =>
          !!v || this.$t("profile") + " " + this.$t("fieldRequired")
      };
    },
    footerProps: function() {
      return {
        "items-per-page-options": [10, 20, -1],
        "items-per-page-text": this.$t("itemsPerPage"),
        "items-per-page-all-text": this.$t("all"),
        "page-text": "{0}-{1}  /  {2}"
      };
    },
    selectedProfilesRole: function() {
      let vm = this;
      let selectedProfile = this.profileResponse.find(
        x => x.name == this.userForm.profile
      );
      if (selectedProfile != null) {
        let selectedRoleList = [];
        selectedProfile.roles.forEach(element => {
          if (vm.roleList.find(x => x.value == element.id) != null) {
            selectedRoleList.push(
              vm.roleList.find(x => x.value == element.id).text
            );
          }
        });
        return selectedRoleList;
      }
      return [];
    },
    profileInformationChanged: function() {
      return (
        this.profileForm.name != this.profileForm.currentName ||
        this.profileForm.description != this.profileForm.currentDescription
      );
    },
    unitCodeTypePair: function() {
      let pair = [];
      for (const user of this.items) {
        if (
          user.unitCode != null &&
          !pair.some(x => x.unitCode === user.unitCode)
        ) {
          pair.push({
            unitType: user.unitType,
            unitCode: user.unitCode
          });
        }
      }
      pair.sort(function(a, b) {
        if (b.unitCode == "001") {
          return 1;
        } else if (a.unitCode == "001") {
          return -1;
        } else {
          return a.unitType.localeCompare(b.unitType);
        }
      });
      return pair;
    }
  },
  beforeMount: function() {
    const previouslySetItemsPerPage = this.$store.getters["itemsPerPageMap"][
      this.pageType
    ];
    if (previouslySetItemsPerPage != null) {
      this.pageOptions.itemsPerPage = previouslySetItemsPerPage;
    }

    this.refreshTable();
    this.getProfiles();
    AuthorizationApi.getRoles(
      this,
      {
        "sort.direction": "ASC",
        "sort.field": "id",
        size: -1
      },
      response => {
        if (response != null && response.resultList != null) {
          this.roleList = [];
          this.rolesResponse = response.resultList;
          response.resultList.forEach(element => {
            if (
              element.status == "ACTIVE" &&
              !this.ineligibleRoles.includes(element.name)
            ) {
              this.roleList.push({
                text: element.description,
                name: element.name,
                value: element.id
              });
            }
          });
          this.roleList.sort(function(a, b) {
            return a.text.localeCompare(b.text);
          });
        }
      },
      error => {}
    );
  },
  methods: {
    getNextUnitCode: function() {
      return (
        Math.max.apply(
          Math,
          this.unitCodeTypePair.map(x => {
            return parseInt(x.unitCode);
          })
        ) + 1
      );
    },
    getProfiles: function() {
      AuthorizationApi.getProfiles(
        this,
        {
          "sort.direction": "ASC",
          "sort.field": "id",
          size: -1
        },
        response => {
          if (response != null && response.resultList != null) {
            this.profileList = [];
            this.profileResponse = response.resultList;
            response.resultList.forEach(element => {
              if (
                element.status == "ACTIVE" &&
                !this.ineligibleProfiles.includes(element.name)
              ) {
                this.profileList.push({
                  id: element.id,
                  text: this.$t(element.name),
                  name: element.name,
                  roles: element.roles,
                  description: element.description
                });
              }
            });
          }
        },
        error => {}
      );
    },
    async refreshTable() {
      let vm = this;
      let users = await this.getUsers();
      this.items = users
        .filter(x => !this.ineligibleProfiles.includes(x.profile))
        .map(function(element) {
          return {
            id: element.id,
            status : element.status,
            statusLabel : vm.$t(element.status),
            email: element.email,
            userName: element.userName,
            fullName: element.fullName,
            profile: element.profile,
            profileLabel: vm.$t(element.profile),
            unitCode: element.unitCode,
            unitCodeLabel: vm.$t(element.unitType),
            pool:
              element.unitCode === "001"
                ? vm.$t(element.unitType)
                : vm.$t("branch"),
            unitType: element.unitType
          };
        });
    },
    getUsers: function() {
      return new Promise(resolve => {
        AuthorizationApi.getUsers(
          this,
          response => {
            if (response != null && response.resultList != null) {
              resolve(
                response.resultList.filter(
                  user => user.domainId == this.$store.getters["user"].domainId
                )
              );
            }
            resolve([]);
          },
          error => {
            resolve([]);
          }
        );
      });
    },
    createProfile: function() {
      return new Promise(resolve => {
        AuthorizationApi.createProfile(
          this,
          this.createProfileRequest,
          response => {
            if (response != null) {
              resolve(response.entityId);
            }
          },
          error => {
            console.log(error);
          }
        );
      });
    },
    updateProfile: function() {
      return new Promise(resolve => {
        AuthorizationApi.updateProfile(
          this,
          this.profileForm.id,
          this.updateProfileRequest,
          response => {
            if (response != null) {
              resolve(true);
            }
          },
          error => {
            console.log(error);
          }
        );
      });
    },
    updateRoles: function() {
      return new Promise(resolve => {
        AuthorizationApi.updateRoles(
          this,
          this.profileForm.id,
          this.updateRolesRequest,
          response => {
            if (response != null) {
              resolve(true);
            }
          },
          error => {
            resolve(false);
          }
        );
      });
    },
    onPageChanged: function(page) {
      this.pageOptions.page = page;
    },
    closeDialog: function() {
      this.userForm.visible = false;
      this.profileForm.visible = false;
    },
    prepareUserRequest: function() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        if (this.userForm.type == 1) {
          this.createUserRequest = {
            user: {
              email: this.userForm.email,
              fullName: this.userForm.fullName,
              profile: this.userForm.profile,
              language: "1",
              password: "123456",
              tenantId: this.$store.getters["user"].domainId,
              unitCode: this.userForm.unitCode.unitCode,
              unitType: this.userForm.unitCode.unitType,
              userName: this.userForm.userName,
              userType: "1"
            }
          };
        } else if (this.userForm.type == 2) {
          this.updateUserRequest = {
            user: {
              email: this.userForm.email,
              fullName: this.userForm.fullName,
              userName: this.userForm.userName,
              unitCode: this.userForm.unitCode.unitCode,
              unitType: this.userForm.unitCode.unitType,
              language: "1"
            }
          };
          if (this.userForm.profile != this.userForm.currentProfile) {
            this.updateUserRequest.user.profile = this.userForm.profile;
          }
        }
        this.userForm.step++;
      } else {
        this.$eventHub.$emit("error-happened", {
          title: "warning",
          id: "",
          warningMessage: this.$t("pleaseFillInAllFields")
        });
      }
    },
    prepareProfileRequest() {
      const isValid = this.$refs.profileForm.validate();
      if (isValid) {
        if (this.profileForm.type == 1) {
          this.createProfileRequest = {
            profile: {
              name: this.profileForm.name,
              description: this.profileForm.description
            }
          };
        } else if (this.profileForm.type == 2) {
          this.updateProfileRequest = {
            profile: {
              id: this.profileForm.id,
              name: this.profileForm.name,
              description: this.profileForm.description
            }
          };
        }
        this.profileForm.step++;
      } else {
        this.$eventHub.$emit("error-happened", {
          title: "warning",
          id: "",
          warningMessage: this.$t("pleaseFillInAllFields")
        });
      }
    },
    prepareUpdateRolesRequest() {
      let vm = this;
      const isValid = this.$refs.assignRolesForm.validate();
      if (isValid) {
        this.updateRolesRequest = {
          addRoles: [],
          deleteRoleIds: []
        };
        this.updateRolesRequest.addRoles.push({
          id: this.rolesResponse.find(x => x.name == "BaseRole").id
        });

        let addRolesArr = this.profileForm.roles.filter(x => !this.profileForm.currentRoles.includes(x));
        let deleteRoleIdsArr = this.profileForm.currentRoles.filter(x => !this.profileForm.roles.includes(x));

        addRolesArr.forEach(function(role) {
          vm.updateRolesRequest.addRoles.push({
            id: role
          });
        });

        deleteRoleIdsArr.forEach(function(role) {
          vm.updateRolesRequest.deleteRoleIds.push(role);
        });
        
        this.profileForm.step++;
      } else {
        this.$eventHub.$emit("error-happened", {
          title: "warning",
          id: "",
          warningMessage: this.$t("pleaseFillInAllFields")
        });
      }
    },
    createUser() {
      return new Promise(resolve => {
        AuthorizationApi.createUser(
          this,
          this.createUserRequest,
          response => {
            if (response && response.success) {
              resolve(response.entityId);
            } else {
              resolve(false);
            }
          },
          error => {
            resolve(false);
          }
        );
      });
    },
    updateUser() {
      return new Promise(resolve => {
        AuthorizationApi.updateUser(
          this,
          this.userForm.id,
          this.updateUserRequest,
          response => {
            if (response && response.success) {
              resolve(response.entityId);
            } else {
              resolve(false);
            }
          },
          error => {
            resolve(false);
          }
        );
      });
    },
    editUser(item) {
      this.$vuetify.goTo(0, { duration: 300, offset: 0, easing: "linear" });

      this.userForm.visible = true;
      this.userForm.type = 2;

      this.userForm.id = item.id;
      this.userForm.userName = item.userName;
      this.userForm.fullName = item.fullName;
      this.userForm.profile = item.profile;
      this.userForm.email = item.email;
      this.userForm.unitCode = this.unitCodeTypePair.find(
        pair => pair.unitCode == item.unitCode
      );

      this.userForm.currentProfile = item.profile;
    },
    editProfile(item) {
      this.$vuetify.goTo(0, { duration: 300, offset: 0, easing: "linear" });

      this.profileForm.visible = true;
      this.profileForm.type = 2;

      this.profileForm.id = item.id;
      this.profileForm.name = item.name;
      this.profileForm.description = item.description;
      this.profileForm.roles = item.roles
        .filter(this.ifRoleIsEligible)
        .map(x => {
          return x.id;
        });

      this.profileForm.currentName = this.profileForm.name;
      this.profileForm.currentDescription = this.profileForm.description;
      this.profileForm.currentRoles = this.profileForm.roles;
    },
    ifRoleIsEligible(item) {
      let roleName = this.rolesResponse.find(role => role.id == item.id).name;
      if (!this.ineligibleRoles.includes(roleName)) {
        return true;
      }
      return false;
    },
    openUserStatusPopup(item) {
      if (item.status == "ACTIVE") {
        this.deleteUserId = item.id;
        this.userChangeStatusPassiveDialog = true;
      }
      else{
        this.deleteUserId = item.id;
        this.userChangeStatusActiveDialog = true;
      }
    },
    authorizationDynamicLogo(item){
      if (item.status == "ACTIVE") {
        return "mdi-reload";
      }
      else if(item.status == "PASSIVE"){
        return "mdi-pencil";
      } 
    },

    openDeleteUserPopup(item) {
        this.deleteUserId = item.id;
        this.userDeleteDialog = true;
    },
    openDeleteProfilePopup(item) {
      if (this.items.find(x => x.profile == item.name) != null) {
        let userNames = "";
        let usersWithProfile = this.items.filter(x => x.profile == item.name);
        usersWithProfile.forEach((element, index) => {
          if (
            usersWithProfile.length == 1 ||
            usersWithProfile.length == index + 1
          ) {
            userNames += element.fullName;
          } else {
            userNames += element.fullName + ", ";
          }
        });
        this.$eventHub.$emit("error-happened", {
          title: "warning",
          id: "",
          warningMessage: this.$t("thereAreActiveUsersHavingProfile"),
          warningDescription: this.$t("users") + " : " + userNames
        });
      } else {
        this.deleteProfileId = item.id;
        this.profileDeleteDialog = true;
      }
    },
    deleteUser() {
      let vm = this;
      return new Promise(resolve => {
        AuthorizationApi.deleteUser(
          this,
          this.deleteUserId,
          response => {
            vm.userDeleteDialog = false;
            vm.refreshTable();
            vm.$eventHub.$emit("error-happened", {
              title: "warning",
              id: "",
              warningMessage: this.$t("userDeleted")
            });
          },
          error => {
            vm.userDeleteDialog = false;
          }
        );
      });
    },
    changeStatusActive(){
      let vm = this;
      return new Promise(resolve => {
        AuthorizationApi.changeStatusToActiveUser(
          this,
          this.deleteUserId,
          "Active",
          response => {
            vm.userChangeStatusActiveDialog = false;
            vm.refreshTable();
            vm.$eventHub.$emit("error-happened", {
              title: "warning",
              id: "",
              warningMessage: this.$t("userStatusChanged")
            });
          },
          error => {
            vm.userChangeStatusActiveDialog = false;
            vm.refreshTable();
            vm.$eventHub.$emit("error-happened", {
              title: "warning",
              id: "",
              warningMessage: this.$t("Essssrror")
            });
          }
        );
      });
    },
    changeStatusPassive(){
      let vm = this;
      return new Promise(resolve => {
        AuthorizationApi.changeStatusToPassiveUser(
          this,
          this.deleteUserId,
          "Passive",
          response => {
            vm.userChangeStatusPassiveDialog = false;
            vm.refreshTable();
            vm.$eventHub.$emit("error-happened", {
              title: "warning",
              id: "",
              warningMessage: this.$t("userStatusChanged")
            });
          },
          error => {
            vm.userChangeStatusPassiveDialog = false;
            vm.refreshTable();
            vm.$eventHub.$emit("error-happened", {
              title: "warning",
              id: "",
              warningMessage: this.$t("Error111")
            });
          }
        );
      });
    },

    deleteProfile() {
      let vm = this;
      return new Promise(resolve => {
        AuthorizationApi.deleteProfile(
          this,
          this.deleteProfileId,
          response => {
            vm.profileDeleteDialog = false;
            vm.getProfiles();
            vm.$eventHub.$emit("error-happened", {
              title: "warning",
              id: "",
              warningMessage: this.$t("profileDeleted")
            });
          },
          error => {
            vm.profileDeleteDialog = false;
          }
        );
      });
    },
    stepBack: function(form) {
      form.step--;
    },
    finalize: async function() {
      if (this.userForm.type == 1) {
        this.userForm.id = await this.createUser();
        this.$eventHub.$emit("error-happened", {
          title: "success",
          id: "",
          warningMessage: this.$t("userCreated")
        });
      } else if (this.userForm.type == 2) {
        await this.updateUser();
        this.$eventHub.$emit("error-happened", {
          title: "success",
          id: "",
          warningMessage: this.$t("userUpdated")
        });
      }
      this.clearUserForm();
      this.refreshTable();
    },
    finalizeProfile: async function() {
      if (this.profileForm.type == 1) {
        this.profileForm.id = await this.createProfile();
        let rolesUpdated = await this.updateRoles();
        if (rolesUpdated) {
          this.$eventHub.$emit("error-happened", {
            title: "success",
            id: "",
            warningMessage: this.$t("profileCreated")
          });
        }
      } else if (this.profileForm.type == 2) {
        if (this.profileInformationChanged) {
          await this.updateProfile();
        }
        let rolesUpdated = false;
        if (this.updateRolesRequest.addRoles.length > 0) {
          rolesUpdated = await this.updateRoles();
        }
        if (rolesUpdated) {
          this.$eventHub.$emit("error-happened", {
            title: "success",
            id: "",
            warningMessage: this.$t("profileUpdated")
          });
        }
      }
      this.clearProfileForm();
      this.getProfiles();
    },
    clearProfileForm() {
      this.$refs.profileForm.resetValidation();
      this.profileForm = {
        id: null,
        name: null,
        description: null,
        visible: false,
        step: 1
      };
    },
    clearUserForm: function() {
      this.$refs.form.resetValidation();
      this.userForm = {
        id: null,
        userName: null,
        email: null,
        profile: null,
        unitCode: null,
        visible: false,
        step: 1
      };
    },
    onBeforeAddUser() {
      this.clearUserForm();
      this.userForm.visible = true;
      this.userForm.type = 1;
    },
    onBeforeAddProfile() {
      this.clearProfileForm();
      this.profileForm.visible = true;
      this.profileForm.type = 1;
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[a-zA-ZığüşöçİĞÜŞÖÇ.\s]+$/.test(char)) {
        return true;
      } else {
        e.preventDefault();
      }
    },
    onItemsPerPageChanged(itemsPerPage) {
      let itemsPerPageMap = this.$store.getters["itemsPerPageMap"];
      itemsPerPageMap[this.pageType] = itemsPerPage;
      this.$store.dispatch("setItemsPerPageMap", itemsPerPageMap);
    },
    customFilter(value, search, item) {
      let filterObject = JSON.parse(search);
      let searchResult = true;
      for (const filterColumn of Object.keys(filterObject)) {
        if (
          filterObject[filterColumn] != null &&
          filterObject[filterColumn] != ""
        ) {
          if (item[filterColumn] != null) {
            searchResult =
              searchResult &&
              item[filterColumn]
                .toUpperCase()
                .indexOf(filterObject[filterColumn].toUpperCase()) !== -1;
          } else {
            searchResult = false;
          }
        }
      }
      return searchResult;
    },
    onUnitCodeChange: function(item) {
      if (typeof item == "string") {
        let unitCode = this.unitCodeTypePair.find(
          pair => pair.unitType == item
        );
        if (unitCode != null) {
          this.userForm.unitCode = unitCode;
        } else {
          this.userForm.unitCode = {
            unitCode: this.getNextUnitCode(),
            unitType: item
          };
        }
      }
    }
  }
};




// WEBPACK FOOTER //
// ./src/pages/authorization/mixin/AuthorizationPanel.js